import api, {Client} from 'src/services/api'
import {GetClientsParams} from 'src/services/api/endpoints/ClientEndpoint'

const MAX_PAGE_SIZE = 100

export default async function getAllClients({filter, includes}: Pick<GetClientsParams, 'filter' | 'includes'>) {
  const entities: Client[] = []
  let currentPage = 1
  let totalPages = 1
  let lastResponse: Awaited<ReturnType<typeof api.client.getMany>> | undefined

  while (currentPage <= totalPages) {
    const response = await api.client.getMany({
      page: currentPage,
      pageSize: MAX_PAGE_SIZE,
      filter,
      includes,
    })

    lastResponse = response
    const pageData = response.data.data
    entities.push(...pageData.entities)
    totalPages = pageData.totalPages ?? 1
    currentPage += 1
  }

  if (!lastResponse) {
    throw new Error('Failed to load clients')
  }

  return {
    ...lastResponse,
    data: {
      ...lastResponse.data,
      data: {
        ...lastResponse.data.data,
        entities,
        totalElements: entities.length,
        totalPages: 1,
        currentPage: 1,
        pageSize: entities.length,
      },
    },
  }
}
